import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import auth from '../utils/auth';
import '../styles/Navbar.css';
import { CartContext } from '../contexts/CartContext';
import useNavigation from '../hooks/useNavigation';

const Navbar = () => {
    const { navigateTo } = useNavigation();
    const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated());
    const [isAdmin, setIsAdmin] = useState(auth.isAuthorized('admin'));
    const { cartCount } = useContext(CartContext);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleAuthChange = () => {
            setIsAuthenticated(auth.isAuthenticated());
            setIsAdmin(auth.isAuthorized('admin'));
        };

        document.addEventListener('authStateChange', handleAuthChange);

        if (menuOpen) {
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
        }

        return () => {
            document.removeEventListener('authStateChange', handleAuthChange);
            document.body.classList.remove('sidebar-open');
        };
    }, [menuOpen]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const handleMenuItemClick = (path) => {
        setMenuOpen(false);
        navigateTo(path)();
    };

    const handleLogoClick = () => {
        setMenuOpen(false);
        navigateTo('/')();
    };

    return (
        <>
            <div
                className={`navbar-backdrop ${menuOpen ? 'active' : ''}`}
                onClick={closeMenu}
            ></div>

            <div className="navbar sticky">
                <div className="navbar-container">
                    <Link to="/" className="navbar-logo" onClick={handleLogoClick}>EssayWriter</Link>

                    <div className={`menu-icon ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                        <div className="menu-icon-bar"></div>
                        <div className="menu-icon-bar"></div>
                        <div className="menu-icon-bar"></div>
                    </div>

                    <ul className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
                        <li>
                            <Link
                                to="/policy"
                                className="navbar-item"
                                onClick={() => handleMenuItemClick('/policy')}
                            >
                                Policy
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/kundvagn"
                                className="navbar-item"
                                onClick={() => handleMenuItemClick('/kundvagn')}
                            >
                                Kundvagn ({cartCount})
                            </Link>
                        </li>
                        {isAuthenticated ? (
                            <>
                                {isAdmin && (
                                    <li>
                                        <Link
                                            to="/kontrollpanel"
                                            className="navbar-item"
                                            onClick={() => handleMenuItemClick('/kontrollpanel')}
                                        >
                                            Kontrollpanel
                                        </Link>
                                    </li>
                                )}
                                <li>
                                    <Link
                                        to="/mitt-konto"
                                        className="navbar-item"
                                        onClick={() => handleMenuItemClick('/mitt-konto')}
                                    >
                                        Mitt konto
                                    </Link>
                                </li>
                            </>
                        ) : (
                            <li>
                                <Link
                                    to="/logga-in"
                                    className="navbar-item"
                                    onClick={() => handleMenuItemClick('/logga-in')}
                                >
                                    Logga in
                                </Link>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default Navbar;